import { useQuery } from "@tanstack/react-query";
import { composeUrl } from "@foundation/util";
import { SECTION_FRONT_REFRESH_INTERVAL_IN_MS } from "~constants";
import { SectionFrontSection } from "~types/sectionfront";
import { logError } from "~utils/newrelic/newrelicBrowser";

async function fetchSectionFrontSectionsData(
  sectionFrontName: string,
  tabIdentifier: string,
  locale: string
) {
  const sectionFrontApi = composeUrl({
    pathname: "/bazaar/api/section-front/sections",
    searchParams: { sectionFrontName, tabIdentifier, locale },
    trailingSlash: false,
  });

  try {
    const response = await fetch(sectionFrontApi, {
      credentials: "same-origin",
    });

    if (!response.ok) return null;

    return response.json();
  } catch (error) {
    logError(new Error("Error refreshing SectionFront data"), {
      sectionFront: sectionFrontName,
      sectionFrontTab: tabIdentifier,
      errorMsg: JSON.stringify(error),
    });

    throw error;
  }
}

export const useSectionFrontData = (
  sectionFrontName: string,
  tabIdentifier: string,
  locale: string
) =>
  useQuery<SectionFrontSection[]>({
    queryKey: ["sectionFrontName", sectionFrontName, tabIdentifier, locale],
    queryFn: () =>
      fetchSectionFrontSectionsData(sectionFrontName, tabIdentifier, locale),
    refetchInterval: SECTION_FRONT_REFRESH_INTERVAL_IN_MS,
    // disable first fetch, page loads with server data
    enabled: false,
  });
